import {Component, Input} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-edit-customer-company-details',
    templateUrl: './edit-customer-company-details.component.html',
    standalone: false
})
export class EditCustomerCompanyDetailsComponent {
  @Input() mainForm: FormGroup;
  @Input() showEmail: boolean = false;

  readonly requiredValidator = Validators.required;
  validationMessages = {};
}
